import { QueovalBase, QueovalDate } from "../global";

export class InsertImageModel extends QueovalBase {
  public ListImage: Array<ImageClient>;
  public SelectedImage: ImageClient;
}

export class ImageClient  {
  public Name: string;
  public Path: string;
  public Extension: string;
  public UpdateDate: QueovalDate;
}
